import * as React from 'react'
import Box from '@mui/material/Box'
import WorkRegionHeader from 'vendors/components/workRegion/WorkRegionHeader'
import WorkRegionList from 'vendors/components/workRegion/WorkRegionList'
import Button from '@mui/material/Button'
import { Link as RouterLink, Navigate, useParams } from 'react-router-dom'
import ListSkeleton from 'vendors/components/skeletons/ListSkeleton'
import useWorkRegion from 'vendors/components/workRegion/useWorkRegion'
import { useTranslation } from 'react-i18next'

const VendorWorkRegionStep: React.FC<{ baseUrl: string }> = ({ baseUrl }) => {
  const { vendorId } = useParams<{ vendorId: string }>()
  const { t } = useTranslation()

  const { workRegionListProps, isLoading, isError } = useWorkRegion(vendorId as string)

  if (isError) {
    return <Navigate to="/error" replace />
  }

  return (
    <Box sx={{ px: 2, pb: 2 }}>
      <WorkRegionHeader />

      <Box>{isLoading ? <ListSkeleton items={5} /> : <WorkRegionList {...workRegionListProps} />}</Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end'
        }}
      >
        <Button sx={{ mt: 3 }} disabled={isLoading} variant="contained" component={RouterLink} to={`${baseUrl}/done`}>
          {t('next')}
        </Button>
      </Box>
    </Box>
  )
}

export default VendorWorkRegionStep
